import MultiValueCookie from './multiValueCookie';
import parseCookieString from './utils/parseCookieString';

export default function parseMultiValueCookie(
  cookieName: string,
  cookiesString: string,
): MultiValueCookie | null {
  const cookieValue = parseCookieString(cookieName, cookiesString);
  return cookieValue ? new MultiValueCookie(cookieValue) : null;
}
